import * as React from "react";
import ReactPlayer from 'react-player'
import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button,ButtonGroup, Card, Elevation, Overlay,H4,Slider,Icon } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'

import {Toaster, Position} from "@blueprintjs/core";
import CardEditor from "./CardEditor.tsx";

const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});


export default class CardDocument extends React.Component  <HomeProps> {
  state = {
    name: '',
    force_height:'240px',
    force_height2:'480px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    url_video_zoom:'zoom/?url=',
    url_video_zoom_saved:'',
    url_video_saved:'',
    recordingsbydate:[],
    crossdomain:false,
    loadthegraph:'',
    lastdaterecorded:'',
    needloadthegraphsaved:'',
    loadthegraphsaved:false,
    isOpenEditor:false,
    isSaveEditor:false,
    tailletexte:0,
    contenu:'',
    volume:50,
    volumesaved:50
  }  
  conteneurRef=null;
  
  constructor(props) {
        super(props);
        if(this.props.handleEdition!=undefined)this.props.handleEdition.bind(this);
        this.conteneurRef = React.createRef()
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
  // console.log("componentDidMount dans CardDocument")
  //  console.log(this.props);
  var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   var host=window.location.toString();
   var ll=host;
   if(ll.split('https:').length>1)host="";
   if(ll.split('http:').length>1)host="";
   //this.setState({url_video_zoom:'zoom/?url='+host+this.props.url_video});
   this.setState({url_video_zoom:host+this.props.url_video});
   this.setState({url_video2:this.props.url_video});
   
    if(this.props.type_audio =='true') {
      this.setState({force_height:'80px'}); 
      this.setState({loadthegraph:'needloaded'})
    }
    if(this.props.type_audio =='true') this.setState({parent_height:280})
    else this.setState({parent_height:480})
    if(this.props.type_audio =='true') this.setState({typeflex:'100%'})
    else this.setState({typeflex:'initial'})
       
  /*  if(this.props.config =='true') {
      this.setState({force_width:'480px'});
    }*/
  }
  
  componentDidUpdate(prevProps, prevState) {
    
   /* if(prevProps.title_document!=this.state.title_document_creation) this.setState({title_document_creation:prevProps.title_document});
    if(prevProps.description!=this.state.description_document_creation) this.setState({description_document_creation:prevProps.description});
    if(prevProps.objectif!=this.state.objectif_document_creation) this.setState({objectif_document_creation:prevProps.objectif});*/
    if(this.state.recordingsbydate!=this.props.recordingsbydate)
    {
      
      this.setState({recordingsbydate:this.props.recordingsbydate});
      if(this.props.type_audio=='true')
      {
        if(this.props.recordingsbydate!=undefined)
        {
          var id_saved=0;
          this.props.recordingsbydate.map((item)=>
          {
            item.recordings.map((it)=>{
              if(it.type=="audio")
              {
                //if (it.data.includes(this.props.userid+"_"+this.props.id_document+".mp3"))
                var iid=parseInt(it.id_document)
                if (iid==this.props.id_document)
                {
                  //on charge le dernier enregistrement audio
                  if(it.id>id_saved)
                  {
                    id_saved=it.id;
                    console.log("a charger");
                    this.setState({url_video_saved:it.data});
                    this.setState({needloadthegraphsaved:'needloadedsaved'});
                    this.setState({lastdaterecorded:it.date})
                    
                  //this.loadText(it.data);
                  }
                }
              }
            })
          });
        }
      }
    }
    /*if(this.props.url_video_saved!==this.state.url_video_saved)
    {
      this.setState({url_video_saved:this.props.url_video_saved})
      if(this.props.url_video_saved !=undefined) this.setState({loadthegraph:'needloadedsaved'})
    }*/
    if(this.state.loadthegraph=='needloaded')
    {
        if(this.state.url_video_zoom!="")if(window.load_graph!=undefined)
        {
          var ret=window.load_graph(this.state.url_video_zoom,this.props.id_document,256);
          if(ret==1) 
          {
            this.setState({loadthegraph:'loaded'})
            window.set_volume(this.props.id_document,this.state.volume);
          }
        }
    }
    if(this.state.needloadthegraphsaved=='needloadedsaved')
    {
      var host=window.location.toString();
      var ll=host;
      if(ll.split('https:').length>1)host="";
      if(ll.split('http:').length>1)host="";
      var url_video_zoom_saved=host+this.state.url_video_saved;
      //this.setState({url_video_zoom:'zoom/?url='+host+this.props.url_video});
      //this.setState({url_video_zoom_saved:url_video_zoom_saved});  
      if(url_video_zoom_saved!="")if(window.load_graph!=undefined)
      {
        var ret=1;
        if(this.state.loadthegraphsaved==false) ret=window.load_graph(url_video_zoom_saved,this.props.id_document+"saved",256);
        else window.load_graph_file(url_video_zoom_saved,this.props.id_document+"saved");
        if(ret==1) 
        {
          this.setState({needloadthegraphsaved:'loaded'});
          this.setState({loadthegraphsaved:true});
          window.set_volume(this.props.id_document+"saved",this.state.volumesaved);
        }
      }
    }
    if(prevProps.youtube_frame!=this.state.youtube_frame) this.setState({youtube_frame:prevProps.youtube_frame});
    if(prevProps.youtube_frame=='true') 
    {
      if(prevProps.url_video!=this.state.url_video) this.setState({url_video:prevProps.url_video});
    }
    else{
      if(prevProps.url_video!=this.state.url_video2) this.setState({url_video2:prevProps.url_video});
    }
    if(this.props.type_audio !='true')
    {
      if(this.conteneurRef.clientWidth!=undefined) 
      {
        
       
        if(this.conteneurRef.clientWidth>0) {
          var larg=this.conteneurRef.clientWidth;
          larg=larg/1.33;
          larg=parseInt(larg);
          if(this.state.force_height != larg)
          {
            this.setState({force_height:larg});
            larg=larg*2;
            
            this.setState({force_height2:larg});
          }
        }
        console.log(this.conteneurRef.clientWidth);
      }
    }
    //console.log(this.state.youtube_frame);
    ////<div dangerouslySetInnerHTML={{ __html: "<iframe style='height:280px;' src='"+url_video+"' />"}} />
  }
  
  handle_published=()=>
  {
    console.log("handle_published");
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le document n'est plus disponible en ligne"});
    }
  }
getChangeHandler(key: string,id) {
    
   return (value: number) => {window.set_volume(id,value);this.setState({ [key]: value });}
} 
handletaille=()=>{
  this.setState({force_width:"100%"});
  this.setState({showcontenu:"block"});
  this.setState({elargir:"arrow-left"});
  if(this.state.elargir=='arrow-right')
  {
    var c1=document.querySelector('#waveform'+this.props.id_document+"saved");
    var c2=document.querySelector('#waveform'+this.props.id_document);
    if(c1!=undefined)window.zoom_in_out(this.props.id_document+"saved",5);
    if(c2!=undefined)window.zoom_in_out(this.props.id_document,5);
  }
}
   render() {
    
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     <div style={{display:isnotdocument,width:this.state.force_width,minWidth: 360,margin:4,flex:this.state.typeflex,zIndex:1}}>
     
     
     <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={false} elevation={Elevation.TWO}>
     <div style={{textAlign: 'right'}}>
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});this.setState({typeflex:'initial'})}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"480px"});this.setState({showcontenu:"block"});if(this.props.type_audio =='true') this.setState({typeflex:'100%'});if(this.props.type_audio =='true') this.setState({parent_height:280})}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
       <Button onClick={(ev)=>{
          ev.preventDefault();
          if(this.state.elargir=='arrow-right')
          {
            this.setState({force_width:"100%"});
            this.setState({showcontenu:"block"});
            this.setState({elargir:"arrow-left"});
            window.zoom_in_out(this.props.id_document+"saved",5);
            window.zoom_in_out(this.props.id_document,5);
          }
          else
          {
            this.setState({force_width:"360px"});
            this.setState({elargir:"arrow-right"});
            window.zoom_in_out(this.props.id_document+"saved",-5);
            window.zoom_in_out(this.props.id_document,-5);
          }
        }}
              
        className={Classes.OUTLINED } icon={this.state.elargir} title="Elargir" />
     </div>
     <h3><a href="">{title_document}</a></h3>
     <p><b>{description}</b></p>
     <p>{objectif}</p>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     {this.props.toolbar!='true'?<CardEditor _onUploadtext={this.props._onUploadtext} fromChildren={this.props.fromChildren} matiere_id={this.props.matiere_id} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} id_document={this.props.id_document} title_document={title_document}/>:null}
     <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
     <div ref={(ref) => this.conteneurRef = ref} style={{display:this.state.showcontenu,margin: '10px 0'}}>
     {/*type_audio =='true' ? <Button style={{marginLeft:10}} onClick={(ev)=>{ev.preventDefault();if(this.state.force_width=='100%')this.setState({force_width:'360px'}); else this.setState({force_width:'100%'})}}>{this.state.force_width =='100%' ? 'Réduire' : 'Agrandir'}</Button> :<div></div> */}
     {/*type_audio =='true' ? this.state.force_width =='100%'?<iframe style={{height:'420px',width:'100%',border:0}} id="id_frame_audio" src={this.state.url_video_zoom} />:null:null*/}
     {type_audio =='true' ?
        <div> 
        <div style={{height:'256px'}} id={"waveform" +this.props.id_document}></div>
        <div id={"timeline"+this.props.id_document}></div>
        <div><Icon style={{margin: "20px 0 0 15px"}} icon="volume-up" size={20}></Icon><div style={{marginLeft: 50, marginTop: -20, width: 200}}><Slider onChange={this.getChangeHandler("volume",this.props.id_document)} value={this.state.volume} min={0}  labelStepSize={25} stepSize={1} max={100}></Slider></div></div>
        <ButtonGroup style={{padding:10}} minimal={false} large={true}><Button onClick={()=>{this.props.handleSetordreRecorder('play');}} intent={Intent.PRIMARY} icon='play' id={'idbtnplay'+this.props.id_document} data-action="play"></Button><Button onClick={()=>{this.props.handleSetordreRecorder('pause');}} style={{marginLeft:2}}intent={Intent.SUCCESS} icon='pause' id={'idbtnpause'+this.props.id_document} disabled={this.props.compteur==-1} data-action="pause"></Button> <Button onClick={()=>{this.props.handleSetordreRecorder('stop');}} style={{marginLeft:2}} intent={Intent.WARNING} icon='stop' id={'idbtnstop'+this.props.id_document} data-action="stop"></Button><Button id={'idbtnrecord'+this.props.id_document} style={{marginLeft:2}} icon="record" intent={Intent.DANGER} disabled={this.props.ordrerecorder=='pauseon'||this.props.compteur>0} onClick={()=>{this.props.handleSetordreRecorder('record');this.props.handle_select_document(this.props.id_document,this.props.title_document);}}></Button><Button style={{marginLeft:10}}icon="zoom-in"  id={'idbtnzoomin'+this.props.id_document}data-action="zoomin"></Button><Button style={{marginLeft:2}} icon="zoom-out"  id={'idbtnzoomout'+this.props.id_document}data-action="zoomout"></Button></ButtonGroup>
        {this.state.loadthegraphsaved?<div style={{marginTop: 10, borderTop: "1px dotted #ccc"}}><a>Votre dernier enregistrement du {this.state.lastdaterecorded}</a></div>:null}
        <div style={{height:this.state.loadthegraphsaved?'256px':"0"}} id={"waveform" +this.props.id_document+"saved"}></div>
        <div id={"timeline"+this.props.id_document+"saved"}></div> 
        {this.state.loadthegraphsaved?<div><Icon style={{margin: "20px 0 0 15px"}} icon="volume-up" size={20}></Icon><div style={{marginLeft: 50, marginTop: -20, width: 200}}><Slider onChange={this.getChangeHandler("volumesaved",this.props.id_document+"saved")} value={this.state.volumesaved} min={0}  labelStepSize={25} stepSize={1} max={100}></Slider></div></div>:null}
        <ButtonGroup style={{display:this.state.loadthegraphsaved?'flex':'none',padding:10}} minimal={false} large={true}><Button onClick={()=>{this.props.handleSetordreRecorder('play');}} intent={Intent.PRIMARY} icon='play' id={'idbtnplay'+this.props.id_document+"saved"} data-action="play"></Button><Button onClick={()=>{this.props.handleSetordreRecorder('pause');}} style={{marginLeft:2}}intent={Intent.SUCCESS} icon='pause' id={'idbtnpause'+this.props.id_document+"saved"} disabled={this.props.compteur==-1} data-action="pause"></Button> <Button onClick={()=>{this.props.handleSetordreRecorder('stop');}} style={{marginLeft:2}} intent={Intent.WARNING} icon='stop' id={'idbtnstop'+this.props.id_document+"saved"} data-action="stop"></Button><Button style={{marginLeft:10}}icon="zoom-in"  id={'idbtnzoomin'+this.props.id_document+"saved"}data-action="zoomin"></Button><Button style={{marginLeft:2}} icon="zoom-out"  id={'idbtnzoomout'+this.props.id_document+"saved"}data-action="zoomout"></Button></ButtonGroup>

        </div>:null}
     {this.state.youtube_frame=='true' ?  <div style={{padding:5,margin:"5px"}}><a href={this.state.url_video} target="_blank"><b>Visiter le site</b></a></div>:<div></div>} 
     {this.state.youtube_frame=='true' ?  <div style={{height:this.state.force_height2}}  dangerouslySetInnerHTML={{ __html: '<iframe  id="id_frame" style="height:100%;width:100%;border:0" src="'+encodeURI(this.state.url_video)+'" />'}} /> : <div id={"id_react_player"+this.props.id_document} ><ReactPlayer url={this.state.url_video2} controls={true} width='100%' height={this.state.force_height} /></div>}
     </div>
     </Card>
     <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Edition d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:ev.target.value,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation});this.setState({title_document_creation:ev.target.value})}} value={this.state.title_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:ev.target.value,objectif:this.state.objectif_document_creation});this.setState({description_document_creation:ev.target.value})}} value={this.state.description_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:ev.target.value});this.setState({objectif_document_creation:ev.target.value})}} value={this.state.objectif_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation,update:true});this.setState({isOpenEdit:false});}}>Valider la modification</Button>
        </div>
      </div>
      </Overlay>
     
     
     </div>);
}
}
